import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  auth: null,
};

const usersSlice = createSlice({
  name: "Users",
  initialState,
  reducers: {
    updateUser(state, action) {
      state.user = {
        ...state.user,
        ...action.payload,
      };
    },
    updateAuth(state, action) {
      state.auth =
        action.payload === null
          ? null
          : {
              ...state.auth,
              ...action.payload,
            };
    },
    resetAll(state) {
      for (const index in initialState) {
        state[index] = initialState[index];
      }
    },
  },
});

export const selectAuthToken = (state) => state.users.auth?.token;
export const selectRefreshToken = (state) => state.users.auth?.refresh_token;

export const { updateUser, updateAuth, resetAll } = usersSlice.actions;

export default usersSlice?.reducer;
